import { backendAuthenticatedAxios } from '../../lib/backend';
import ServerSideAutocomplete from '../../lib/recoil/ServerSideAutocomplete';
import { Institution } from '../../types/eligibility';

const INSTITUTION_AUTOCOMPLETE_MIN_QUERY_LENGTH = 4;

/**
 * Manages state associated with the Autocomplete component for Institutions
 */
const institutionAutocomplete = new ServerSideAutocomplete<Institution>(
  'institution',
  async (query) => {
    if (query.length && query.length >= INSTITUTION_AUTOCOMPLETE_MIN_QUERY_LENGTH) {
      const response = await backendAuthenticatedAxios.get<InstitutionApiResponse>(`institution/?q=${query}`);

      return response.data.results;
    }

    return [];
  },
  true,
);

interface InstitutionApiResponse {
  results: Institution[];
}

export default institutionAutocomplete;
